import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { useCtxReportableFiscalYears } from './useCtxReportableFiscalYears'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { sortedPeriodGroupSelector } from '../selectors/selectors'

export const useCtxReportablePeriodGroups = () => {
  const filters = useSelector(filtersSelector)
  const { data: reportable } = useCtxReportableFiscalYears()
  const reportablePeriodGroups = useMemo(() => sortedPeriodGroupSelector(filters, reportable), [filters, reportable])
  return reportablePeriodGroups
}
